export const BOOKING_WEBSITE_APP_SOURCE = 'Booking Website'
export const WEBSITE_WIDGET_APP_SOURCE = 'Website Widget'
export const BRANDED_APP_APP_SOURCE = 'Branded App'
